import { render, staticRenderFns } from "./MemberAccountForm.vue?vue&type=template&id=2273a638&"
import script from "./MemberAccountForm.vue?vue&type=script&lang=js&"
export * from "./MemberAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports